module.exports = __webpack_public_path__ + "images/156_1024.jpg";